module.exports = __webpack_public_path__ + "img/en_jiaoyu.81854430.jpg";